module.exports = __webpack_public_path__ + "img/p-3.95db1d3a.png";